import { useToast } from 'vue-toastification/composition';
import BaseToastTemplate from './BaseToastTemplate.vue';

export enum BaseToastTypeEnums {
  SUCCESS = 'success',
  INFO = 'info',
  DANGER = 'danger'
}

declare interface BaseToastProps {
  type: BaseToastTypeEnums;
  title: string;
  text: string;
  actionLabel?: string;
  action?: () => void;
}

interface BaseToastContent {
  component: typeof BaseToastTemplate;
  props: BaseToastProps;
  toastClassName: string;
}

/**
 * Builds the content object passed to vue-toastification's toast methods,
 * rendering the shared {@link BaseToastTemplate} with the given props.
 *
 * @param options - Toast content; `actionLabel` + `action` add an optional
 *   action button (both are required for the button to render).
 * @returns The toast content descriptor (component, props and class name).
 */
export const createToastTemplate = (options: BaseToastProps): BaseToastContent => ({
  component: BaseToastTemplate,
  props: {
    type: options.type,
    title: options.title,
    text: options.text,
    actionLabel: options.actionLabel,
    action: options.action,
  },
  toastClassName: 'base-toast-template',
});
